namespace TabAurous.ECommerce {
    export namespace ECommRepairService {
        export const baseUrl = 'ECommRepair/ECommRepair';

        export declare function Create(request: Serenity.SaveRequest<ECommRepairRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommRepairRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommRepairRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommRepairRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Authorize(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommRepair/ECommRepair/Create",
            Update = "ECommRepair/ECommRepair/Update",
            Delete = "ECommRepair/ECommRepair/Delete",
            Retrieve = "ECommRepair/ECommRepair/Retrieve",
            List = "ECommRepair/ECommRepair/List",
            Authorize = "ECommRepair/ECommRepair/Authorize"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Authorize'
        ].forEach(x => {
            (<any>ECommRepairService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
